import axios from "../config/axiosInstance";

export const tourAssignmentService = {
  getPendingTourAssignments: async (page, pageSize) => {
    return await axios.get("/tour-assignment/get-all", {
      params: { page, pageSize },
    });
  },

  getTourAssignmentById: async (tourAssignmentId) => {
    return await axios.get(`/tour-assignment/${tourAssignmentId}`);
  },

  getRecommendedTourGuides: async (tourId, startDate, endDate) => {
    return await axios.get(
      `/tour-guide/recommend?tourId=${tourId}&startDate=${startDate}&endDate=${endDate}`
    );
  },

  assignTourGuides: async (tourAssignmentId, mainGuideId, backupGuideId) => {
    return await axios.post(
      `/tour-assignment/assign-tour?tourAssignmentId=${tourAssignmentId}&mainGuideId=${mainGuideId}&backupGuideId=${backupGuideId}`
    );
  },

  getTourGuideAssignments: async (userId) => {
    return await axios.get(`/tour-assignment/assignments/${userId}`);
  },

  confirmTourGuide: async (tourGuideAssignmentId) => {
    return await axios.put(`/tour-assignment/confirm/${tourGuideAssignmentId}`);
  },

  cancelTourGuide: async (tourGuideAssignmentId) => {
    return await axios.put(`/tour-assignment/cancel/${tourGuideAssignmentId}`);
  },

  getTourGuideAssignmentsByTour: async (tourAssignmentId) => {
    return await axios.get(
      `/tour-assignment/tour-guide-assignments/${tourAssignmentId}`
    );
  },
};
